export const NAV_ITEMS = [
  'family-history',
  'familysearch',
  'family-tree',
  'wall-art',
  'desk',
  'photo-books',
  'calendars',
  'magnets',
  'display',
  'giftcard',
];

export const FAVORITE_PRODUCTS = [
  'ancestry-book',
  'ancestry-poster',
  'ancestry-calendar',
  'framed-art-prints',
  'artprint',
  'softcover-books',
];

export const FAVORITE_CATEGORIES = ['family-history', 'photo-books', 'display', 'wall-art'];

export const NEW_PRODUCTS = [
  'acrylic-prints',
  'metal-desk-prints',
  'metal-wall-prints',
  'ancestry-book',
];

export const MIGHT_LIKE_PRODUCTS = [
  'metal-desk-prints',
  'metal-wall-prints',
  'ancestry-book',
  'ancestry-poster',
  'engineer-prints',
  'artprint',
  'softcover-books',
  'wooden-rails',
  'wall-calendar',
];
